import Highcharts from 'highcharts';
import exportingInit from 'highcharts/modules/exporting';
import exportingData from 'highcharts/modules/export-data';
import offlineExporting from 'highcharts/modules/offline-exporting';

exportingInit(Highcharts);
exportingData(Highcharts);
offlineExporting(Highcharts);

Highcharts.setOptions({
  lang: {
    loading: 'Aguarde...',
    months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
    shortMonths: ['Jan', 'Fev', 'Mar', 'Abr', 'Maio', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    exportButtonTitle: 'Exportar',
    printButtonTitle: 'Imprimir',
    rangeSelectorFrom: 'De',
    rangeSelectorTo: 'Até',
    rangeSelectorZoom: 'Período',
    downloadPNG: 'Download imagem PNG',
    downloadJPEG: 'Download imagem JPEG',
    downloadPDF: 'Download documento PDF',
    downloadSVG: 'Download imagem SVG',
    resetZoom: 'Reset',
    resetZoomTitle: 'Reset',
    thousandsSep: '.',
    decimalPoint: ',',
  },
  exporting: {
    enabled: false,
  },
});

export default Highcharts;
